// @ts-nocheck
import * as $ from 'jquery';

$(() => {
    const settingsPageContainer = $('[data-notification-settings-page]');

    if (settingsPageContainer.length === 0) {
        return;
    }

    let container = $(settingsPageContainer[0]);

    $('.notification-setting').on('click', function (e) {
        var $target = $(e.target);
        var $additional = $target.siblings('.additional-data');

        $additional.toggleClass("show", $target.is(":checked"))
    });

    $('.default-notification-email').on('change', function (e) {
        $('.notification-specific-email').each(function (index, elem) {
            $(elem).attr('placeholder', $(e.currentTarget).val());
        })
    });
});